module.exports = __webpack_public_path__ + "files/4f61b0f13e1b8212162dd2d89127083e.png";